var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 343.402,
    height: 151.94,
    viewBox: "0 0 343.402 151.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-177.7 -415.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1",
    "data-name": "Pfad 1",
    d: "M206.28,544.82H329.65V441.55H206.28Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2",
    "data-name": "Pfad 2",
    d: "M177.7,567.26V415.32H329.64v30.388H208.09v91.16H329.64v30.39H177.7Z",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3",
    "data-name": "Pfad 3",
    d: "M266.14,454.68h6.366v20.343c0,2.316.09,2.849.533,3.694.714,1.381,2.182,2.137,4.229,2.137,2.718,0,4.452-1.335,4.719-3.6a19.521,19.521,0,0,0,.09-2.761V454.68H288.4v20.832c0,2.938-.046,3.517-.489,4.852-.8,2.449-3.83,5.833-10.508,5.833-4.716,0-8.146-1.424-9.927-4.14-1.022-1.6-1.335-2.849-1.335-5.833V454.68",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4",
    "data-name": "Pfad 4",
    d: "M294.63,454.68h6.9l5.92,12.373a60.059,60.059,0,0,1,3.384,8.771c-.223-2.4-.446-6.366-.492-8.5l-.133-12.642h5.922v30.938h-6.5l-5.3-11.843c-1.691-3.871-3.6-8.234-4.184-10.15.223,2.539.267,6.189.312,8.771l.177,13.221H294.63V454.679",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5",
    "data-name": "Pfad 5",
    d: "M323.14,485.62h6.5V454.682h-6.5Z",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6",
    "data-name": "Pfad 6",
    d: "M334.16,454.68h6.811l5.118,16.113c.135.535.625,2.137.981,3.474.177.756.267,1.066.443,1.914.179-.891.269-1.158.535-2.226.489-1.647.756-2.4,1.247-3.961l5.252-15.314,6.543-.046-10.772,31.207h-5.654L334.16,454.68",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7",
    "data-name": "Pfad 7",
    d: "M364.48,454.68h17.63l-.8,5.073h-10.6v7.168h8.858v5.075H370.8v8.28H382.51v5.344H364.481V454.68Z",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8",
    "data-name": "Pfad 8",
    d: "M387.18,454.63l11.53.046c5.477,0,9.081,3.65,9.081,9.079,0,4.631-3.072,8.459-6.9,8.548a5.9,5.9,0,0,1,1.289,1.291c1.783,2.226,7.436,12.02,7.436,12.02h-7.345c-1.2-2.049-1.693-2.895-2.895-5.075-3.072-5.564-4.05-7.034-5.121-7.567a2.549,2.549,0,0,0-.979-.269v12.911h-6.1V454.63Zm6.143,5.031-.044,8.369h2.093c2.672,0,3.827-.269,4.673-1.025a4.222,4.222,0,0,0,1.2-3.115c0-1.914-.756-3.207-2.226-3.784a11.182,11.182,0,0,0-3.517-.446h-2.182",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_9",
    "data-name": "Pfad 9",
    d: "M433.84,456.86l-2.938,4.452a13.318,13.318,0,0,0-7.211-2.359c-2.539,0-4.319,1.468-4.319,3.561,0,1.6.848,2.4,3.43,3.115l3.738,1.025c5.075,1.381,7.834,4.629,7.834,9.215,0,6.276-5.073,10.416-12.773,10.416a22.121,22.121,0,0,1-10.552-2.8l2.316-4.852a17.54,17.54,0,0,0,8.5,2.493c3.561,0,5.431-1.47,5.431-4.229,0-2-1.291-3.294-4.052-4.007l-3.428-.935c-3.072-.845-4.985-2.047-6.1-3.917a8.938,8.938,0,0,1-1.289-4.719c0-5.654,4.54-9.571,11.085-9.571a18.163,18.163,0,0,1,10.327,3.115",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10",
    "data-name": "Pfad 10",
    d: "M439.89,485.62h6.5V454.682h-6.5Z",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11",
    "data-name": "Pfad 11",
    d: "M450.46,454.68h22.3l-1.025,5.162h-7.388v25.776h-6.322V459.842H450.46V454.68Z",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12",
    "data-name": "Pfad 12",
    d: "M481.98,454.59H488.7l9.75,31.028h-6.678l-2.18-7.345h-9.081l-2.182,7.345h-6.5l10.15-31.028Zm-1.87-7.923a3.524,3.524,0,0,1,3.474,3.561,3.539,3.539,0,1,1-7.078,0,3.609,3.609,0,0,1,3.6-3.561m1.916,26.442h6.053s-1.025-3.251-1.691-6.233c-.312-1.424-1.247-5.475-1.247-5.475s-.891,3.65-1.47,5.964c-.579,2.226-.979,3.694-1.645,5.743m10.949-22.881a3.57,3.57,0,0,1-3.561,3.561,3.534,3.534,0,0,1-3.517-3.561,3.581,3.581,0,0,1,3.607-3.561,3.524,3.524,0,0,1,3.471,3.561",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13",
    "data-name": "Pfad 13",
    d: "M498.8,454.68h22.3l-1.025,5.162h-7.388v25.776h-6.322V459.842H498.8V454.68Z",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14",
    "data-name": "Pfad 14",
    d: "M266.06,497.52h6.589l2.67,12.2a82.027,82.027,0,0,1,1.647,10.2c.133-1.2.668-5.61,1.6-9.883l2.759-12.509h6.811l2.849,13.844c.579,2.895,1.335,8.192,1.335,8.192.09-.981,1.158-7.7,1.693-10.283l2.536-11.753H303.1l-7.478,31.2h-6.809l-2.761-12.6a84.415,84.415,0,0,1-1.468-8.992s-.623,4.363-1.514,8.9l-2.536,12.686h-7.08l-7.388-31.2",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    "data-name": "Pfad 15",
    d: "M307.37,497.56h6.366V517.9c0,2.313.09,2.849.535,3.694.712,1.378,2.18,2.136,4.229,2.136,2.715,0,4.45-1.337,4.716-3.6a19.538,19.538,0,0,0,.09-2.761V497.56h6.322v20.832c0,2.94-.044,3.519-.489,4.854-.8,2.449-3.83,5.831-10.508,5.831-4.716,0-8.144-1.424-9.924-4.14-1.025-1.6-1.337-2.849-1.337-5.831V497.559",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    "data-name": "Pfad 16",
    d: "M336.61,497.48l11.53.046c5.475,0,9.079,3.65,9.079,9.081,0,4.629-3.072,8.459-6.9,8.546a5.965,5.965,0,0,1,1.291,1.291c1.78,2.226,7.434,12.02,7.434,12.02H351.7c-1.2-2.047-1.691-2.892-2.895-5.075-3.072-5.564-4.05-7.034-5.118-7.567a2.614,2.614,0,0,0-.981-.269v12.911h-6.1V497.48Zm6.143,5.031-.046,8.369H344.8c2.672,0,3.83-.269,4.675-1.022a4.234,4.234,0,0,0,1.2-3.117c0-1.914-.756-3.2-2.226-3.784a11.182,11.182,0,0,0-3.517-.446h-2.18",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_17",
    "data-name": "Pfad 17",
    d: "M363.94,497.52h18.519v4.5L370.975,521.38a17.533,17.533,0,0,1-1.6,2.18s1.826-.177,3.072-.177h10.416l-1.6,5.075h-19.32V524.1l11.4-18.829a31.567,31.567,0,0,1,1.914-2.8,20.731,20.731,0,0,1-3.161.221H362.56l1.381-5.162",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_18",
    "data-name": "Pfad 18",
    d: "M388.42,497.48h10.462c3.781,0,5.741.579,7.611,2.226a6.911,6.911,0,0,1,2.536,5.52,7.182,7.182,0,0,1-2.091,5.208,5.934,5.934,0,0,1-2.849,1.6c4.14,1.245,6.143,3.738,6.143,7.79a8.2,8.2,0,0,1-8.1,8.546c-.979.044-2.27.09-3.963.09H388.42V497.48Zm6.143,5.3V509.9h3.694a5.2,5.2,0,0,0,2.672-.4,4.035,4.035,0,0,0,1.6-3.2,3.536,3.536,0,0,0-1.783-3.115,6.231,6.231,0,0,0-2.582-.4h-3.6Zm.09,12.24v8.369h4.05a4.89,4.89,0,0,0,2.895-.712,4.67,4.67,0,0,0,1.6-3.607,3.912,3.912,0,0,0-2.27-3.784,6.462,6.462,0,0,0-2.4-.267h-3.873",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_19",
    "data-name": "Pfad 19",
    d: "M415.07,497.52h6.366v20.343c0,2.316.087,2.849.533,3.694.712,1.381,2.182,2.139,4.229,2.139,2.715,0,4.452-1.337,4.719-3.607a19.5,19.5,0,0,0,.09-2.759V497.52h6.32v20.832c0,2.938-.044,3.517-.489,4.852-.8,2.449-3.827,5.833-10.506,5.833-4.719,0-8.146-1.424-9.927-4.14-1.025-1.6-1.335-2.849-1.335-5.833V497.52",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_20",
    "data-name": "Pfad 20",
    d: "M444.41,497.48l11.53.046c5.475,0,9.081,3.65,9.081,9.081,0,4.629-3.072,8.459-6.9,8.546a5.916,5.916,0,0,1,1.291,1.291c1.78,2.226,7.436,12.02,7.436,12.02H459.5c-1.2-2.047-1.691-2.892-2.892-5.075-3.074-5.564-4.052-7.034-5.121-7.567a2.6,2.6,0,0,0-.979-.269v12.911h-6.1V497.48Zm6.143,5.031-.044,8.369H452.6c2.672,0,3.83-.269,4.675-1.022a4.226,4.226,0,0,0,1.2-3.117c0-1.914-.756-3.2-2.226-3.784a11.156,11.156,0,0,0-3.515-.446h-2.182",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_21",
    "data-name": "Pfad 21",
    d: "M492.42,500.59l-3.294,3.871a9.8,9.8,0,0,0-6.455-2.4,6.317,6.317,0,0,0-4.452,1.558c-2.091,2-2.626,5.344-2.626,9.973,0,4.406.758,7.257,2.316,8.815a6.868,6.868,0,0,0,4.852,1.735,7.308,7.308,0,0,0,3.517-.756v-7.034h-4.719l-.8-5.075h11.976v14.781a19.917,19.917,0,0,1-10.285,2.759c-4.629,0-8.057-1.514-10.549-4.719-2.27-2.892-3.294-6.187-3.294-10.818,0-6.543,2.137-11.172,6.455-14.067a12.773,12.773,0,0,1,7.524-2.18,14.7,14.7,0,0,1,9.837,3.561",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_22",
    "data-name": "Pfad 22",
    d: "M313.73,488.22a3.428,3.428,0,1,1-3.388,3.391,3.392,3.392,0,0,1,3.388-3.391",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_23",
    "data-name": "Pfad 23",
    d: "M323.35,488.22a3.428,3.428,0,1,1-3.388,3.391,3.392,3.392,0,0,1,3.388-3.391",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_24",
    "data-name": "Pfad 24",
    d: "M339.25,421.95h1.933v13.424c0,.614-.024,1.3-.046,1.724a4.665,4.665,0,0,1-.544,1.981,4.838,4.838,0,0,1-2.737,2.075l-.944-1.2a3.786,3.786,0,0,0,1.935-1.579,6.16,6.16,0,0,0,.4-2.949V421.95",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_25",
    "data-name": "Pfad 25",
    d: "M344.42,426.48l1.815-.354v8.446c0,1.156.142,1.582.684,1.935a2.763,2.763,0,0,0,1.464.448,3.593,3.593,0,0,0,3-2.123V426.5l1.818-.308v8.328a4.364,4.364,0,0,0,.284,2.2,1.741,1.741,0,0,0,.518.66l-1.18,1.252a3.047,3.047,0,0,1-1.274-1.888,4.363,4.363,0,0,1-3.727,1.791,3.132,3.132,0,0,1-3.091-1.673,4.226,4.226,0,0,1-.306-1.748V426.48",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26",
    "data-name": "Pfad 26",
    d: "M356.72,421.36l1.911-.378a12.757,12.757,0,0,1,.282,3.633v11.159c0,.92.142,1.18.662,1.18a1.324,1.324,0,0,0,.236-.048l.376,1.2a2.324,2.324,0,0,1-1.177.26,1.935,1.935,0,0,1-1.394-.5,1.961,1.961,0,0,1-.566-1.676V424.615a9.105,9.105,0,0,0-.33-3.255",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27",
    "data-name": "Pfad 27",
    d: "M363.85,421.32a1.44,1.44,0,1,1-1.44,1.461,1.45,1.45,0,0,1,1.44-1.461m-.992,5.118,1.96-.306v12.009h-1.96v-11.7",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_28",
    "data-name": "Pfad 28",
    d: "M368.8,426.48l1.815-.354v8.446c0,1.156.142,1.582.686,1.935a2.749,2.749,0,0,0,1.461.448,3.6,3.6,0,0,0,3-2.123V426.5l1.815-.308v8.328a4.364,4.364,0,0,0,.284,2.2,1.763,1.763,0,0,0,.518.66l-1.18,1.252a3.047,3.047,0,0,1-1.274-1.888,4.361,4.361,0,0,1-3.727,1.791,3.132,3.132,0,0,1-3.091-1.673,4.226,4.226,0,0,1-.306-1.748V426.48",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_29",
    "data-name": "Pfad 29",
    d: "M388.34,426.86l-.684,1.368a6.7,6.7,0,0,0-2.949-.848,1.97,1.97,0,0,0-2.22,1.933,1.6,1.6,0,0,0,.332,1.038,2.115,2.115,0,0,0,1.368.66l1.558.33c2.123.474,3.137,1.534,3.137,3.281,0,2.287-1.793,3.845-4.435,3.845a8.7,8.7,0,0,1-4.319-1.18l.708-1.368a7.082,7.082,0,0,0,3.729,1.11c1.437,0,2.383-.78,2.383-2.032,0-1.062-.592-1.649-1.935-1.933l-1.464-.308a3.728,3.728,0,0,1-2.217-1.177,3.066,3.066,0,0,1-.754-2.053c0-2.123,1.721-3.609,4.175-3.609a7.664,7.664,0,0,1,3.587.944",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_30",
    "data-name": "Pfad 30",
    d: "M391.31,432.74h4.507v-1.793H391.31Z",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_31",
    "data-name": "Pfad 31",
    d: "M400.06,421.95h2.829l2.949,10.569a23.555,23.555,0,0,1,.638,2.831c.26-1.368.378-1.815.59-2.641l3.043-10.759h2.855l1.392,16.186H412.42l-.944-11.867c-.07-1.038-.118-2.761-.118-2.761-.164.8-.446,1.911-.636,2.547l-3.467,12.081H405.6L402.4,426.647c-.332-1.228-.566-2.03-.8-3.163,0,0-.118,2.147-.19,3.139l-.9,11.513h-1.863l1.416-16.186",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_32",
    "data-name": "Pfad 32",
    d: "M416.36,427.66a8.858,8.858,0,0,1,4.931-1.582,3.194,3.194,0,0,1,3.257,1.842,4.689,4.689,0,0,1,.258,2.005v.59l-.094,3.869a4.315,4.315,0,0,0-.022.542c0,1.44.212,1.957.966,2.335l-.944,1.322a2.414,2.414,0,0,1-1.6-1.721,4.392,4.392,0,0,1-3.4,1.579,3.712,3.712,0,0,1-2.829-.944,3.457,3.457,0,0,1-.944-2.405c0-2.665,2.287-4.223,6.228-4.223.284,0,.424,0,.826.022v-.826c0-1.038-.048-1.461-.378-1.839a1.933,1.933,0,0,0-1.579-.638,5.567,5.567,0,0,0-2.265.52,4.865,4.865,0,0,0-1.488.874l-.92-1.322Zm6.582,4.507c-.4-.024-.59-.048-.92-.048-1.793,0-2.783.33-3.373.944a2.54,2.54,0,0,0-.662,1.863c0,1.394.686,2.147,2.03,2.147a3.224,3.224,0,0,0,2.855-1.842l.07-3.065",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_33",
    "data-name": "Pfad 33",
    d: "M427.43,426.43H429.7l2.311,3.869,2.241-3.869H436.4l-3.469,5.191,4.507,6.512h-2.241l-3.185-5-3.185,5h-2.169l4.389-6.512-3.611-5.191Z",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_34",
    "data-name": "Pfad 34",
    d: "M440.19,421.32a1.44,1.44,0,1,1-1.442,1.461,1.45,1.45,0,0,1,1.442-1.461m-.992,5.118,1.957-.306v12.009H439.2v-11.7",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_35",
    "data-name": "Pfad 35",
    d: "M444.69,426.53l1.793-.424a4.175,4.175,0,0,1,.424,1.652v.094a5.532,5.532,0,0,1,1.44-1.132,3.741,3.741,0,0,1,1.981-.638,2.962,2.962,0,0,1,2.335,1.18,2.617,2.617,0,0,1,.4.78,5.643,5.643,0,0,1,3.775-1.96,2.943,2.943,0,0,1,2.949,3.187v8.869H457.9v-8.681c0-1.134-.52-1.721-1.512-1.721a2.984,2.984,0,0,0-1.721.636,12.662,12.662,0,0,0-1.18.99l-.212.19v8.588h-1.863v-8.352c0-1.016-.024-1.18-.332-1.509a1.446,1.446,0,0,0-1.2-.472c-.9,0-1.767.448-3,1.555v8.778h-1.77v-8.754a5.851,5.851,0,0,0-.424-2.855",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_36",
    "data-name": "Pfad 36",
    d: "M464.58,421.32a1.44,1.44,0,1,1-1.44,1.461,1.448,1.448,0,0,1,1.44-1.461m-.992,5.118,1.957-.306v12.009h-1.957v-11.7",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_37",
    "data-name": "Pfad 37",
    d: "M469.21,421.36l1.911-.378a12.757,12.757,0,0,1,.282,3.633v11.159c0,.92.142,1.18.662,1.18a1.324,1.324,0,0,0,.236-.048l.376,1.2a2.324,2.324,0,0,1-1.177.26,1.939,1.939,0,0,1-1.394-.5,1.961,1.961,0,0,1-.566-1.676V424.615a9.105,9.105,0,0,0-.33-3.255",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_38",
    "data-name": "Pfad 38",
    d: "M476.33,421.32a1.44,1.44,0,1,1-1.44,1.461,1.45,1.45,0,0,1,1.44-1.461m-.992,5.118,1.96-.306v12.009h-1.96v-11.7",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_39",
    "data-name": "Pfad 39",
    d: "M480.72,427.66a8.858,8.858,0,0,1,4.931-1.582,3.194,3.194,0,0,1,3.257,1.842,4.689,4.689,0,0,1,.258,2.005v.59l-.094,3.869a3.929,3.929,0,0,0-.024.542c0,1.44.214,1.957.968,2.335l-.944,1.322a2.414,2.414,0,0,1-1.6-1.721,4.394,4.394,0,0,1-3.4,1.579,3.718,3.718,0,0,1-2.831-.944,3.457,3.457,0,0,1-.944-2.405c0-2.665,2.289-4.223,6.228-4.223.282,0,.424,0,.826.022v-.826c0-1.038-.048-1.461-.378-1.839a1.935,1.935,0,0,0-1.582-.638,5.565,5.565,0,0,0-2.263.52,4.865,4.865,0,0,0-1.488.874l-.92-1.322Zm6.582,4.507c-.4-.024-.59-.048-.92-.048-1.793,0-2.783.33-3.373.944a2.54,2.54,0,0,0-.662,1.863c0,1.394.684,2.147,2.03,2.147a3.224,3.224,0,0,0,2.855-1.842l.07-3.065",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_40",
    "data-name": "Pfad 40",
    d: "M492.66,426.6l1.791-.5a3.945,3.945,0,0,1,.426,1.839,5.269,5.269,0,0,1,3.7-1.815,3.119,3.119,0,0,1,2.877,1.721,3.374,3.374,0,0,1,.284,1.37v8.918h-1.863v-7.952c0-1.25-.07-1.579-.424-1.957a1.728,1.728,0,0,0-1.3-.494,5.406,5.406,0,0,0-3.253,1.649v8.754h-1.793v-8.754a5.127,5.127,0,0,0-.448-2.783",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_41",
    "data-name": "Pfad 41",
    d: "M512.62,426.86l-.684,1.368a6.705,6.705,0,0,0-2.951-.848,1.969,1.969,0,0,0-2.217,1.933,1.625,1.625,0,0,0,.33,1.038,2.132,2.132,0,0,0,1.37.66l1.558.33c2.123.474,3.137,1.534,3.137,3.281,0,2.287-1.791,3.845-4.435,3.845a8.694,8.694,0,0,1-4.317-1.18l.708-1.368a7.069,7.069,0,0,0,3.727,1.11c1.44,0,2.383-.78,2.383-2.032,0-1.062-.59-1.649-1.935-1.933l-1.464-.308a3.728,3.728,0,0,1-2.217-1.177,3.079,3.079,0,0,1-.756-2.053c0-2.123,1.724-3.609,4.177-3.609a7.664,7.664,0,0,1,3.587.944",
    fill: "#004188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_42",
    "data-name": "Pfad 42",
    d: "M516.1,432.74h4.5v-1.793h-4.5Z",
    fill: "#004188"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.63dd3894b82532208924f5d7c7c972dc.svg";
export { ForwardRef as ReactComponent };